/**
 * Shared utilities for field formatters
 */

import type {FinalReviewItemValue} from '../../components/finalReview/finalReviewItem/FinalReviewItem.types'

/**
 * Helper to create FinalReviewItemValue array from old/new values
 */
export const createValueArray = (
  oldValue: string | null,
  newValue: string | null,
  hasChanges: boolean,
  notSpecifiedText: string
): FinalReviewItemValue[] => {
  const values: FinalReviewItemValue[] = []

  if (hasChanges && oldValue && oldValue !== newValue) {
    values.push({text: oldValue, isDiscarded: true, isNew: false})
  }
  if (newValue) {
    values.push({text: newValue, isDiscarded: false, isNew: hasChanges && !!oldValue})
  } else if (!hasChanges || !oldValue) {
    values.push({text: notSpecifiedText, isDiscarded: false, isNew: false})
  }

  return values
}
